import { useBreakpointValue } from '@chakra-ui/react';

const useIsMobile = () => {
  const isMobile = useBreakpointValue({ base: true, md: false }, { ssr: false, fallback: 'md' });

  return isMobile;
};

export default useIsMobile;
